import { InvoiceType } from "types/business/InvoiceType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = InvoiceType[];

export const useDefaultObservableInvoiceTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectInvoiceTypeArray extends BehaviorSubject<CurrentType> {}
